<div class="traffic-source-container">
  <div class="d-flex traffic">
    <div class="image-container">
      <nb-icon class="link-icon" icon="link" pack="icomoon"></nb-icon>
    </div>
    <div class="other-content-container">
      <h5>{{ 'view_translations.traffic_source' | translate }}</h5>
      <p (click)="onAddNewTrafficSource()" class="pointer">{{ 'view_translations.add_new_source' | translate }}</p>
      <ng-select
        notFoundText="{{ 'view_translations.no_data' | translate }}"
        [searchable]="false"
        [(ngModel)]="selectedDomain"
        class="select-menu"
        [ngClass]="{'error-select': submitted && !selectedDomain}"
        (change)="emitDomain()"
        notFoundText="{{ 'view_translations.no_data' | translate }}"
        placeholder="{{ 'view_translations.select_label' | translate }}">
        <ng-option *ngFor="let domain of domains" [value]="domain.id">{{domain.name}}</ng-option>
      </ng-select>
      <nb-icon *ngIf="submitted && !selectedDomain" class="error-icon" icon="cross-circle" pack="icomoon"></nb-icon>
      <div class="error-text" *ngIf="submitted && !selectedDomain">
        <small class="form-text text-danger">{{ 'view_translations.this_field_is_required' | translate }}</small>
      </div>
    </div>
  </div>
</div>
